module.exports = __webpack_public_path__ + "media/images/TH_favicon-a20667a1e65bff55a08305095056e402.png";